import React, { useEffect, useState } from "react";
import { Router } from "react-router-dom";
import { createBrowserHistory } from "history";
import * as BosIdentityServices from "./data/BosWebServices/BosIdentityServices";
import * as AppConfig from "./logic/GlobalAppConfig";
import WebWorkspace from "./WebWorkspace";

// Basic Styles
import "./assets/scss/index.scss";

// Theme customs
import "./theme/devExtreme/index.scss";

// Redux
import store from "./redux/configureStore";
import { Provider as ReduxStoreProvider } from "react-redux";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
export const browserHistory = createBrowserHistory({
  basename: process.env.PUBLIC_URL
});

export default function App() {
  const [inInit, setInInit] = useState(true);

  async function assureClientId() {
    let clientId = AppConfig.getClientId();
    if (!clientId) {
      let newClientSecret = AppConfig.getClientSecret();
      let newClientId = await BosIdentityServices.fetchRegisterNewClient(newClientSecret, "NULL");
      await AppConfig.updateAppConfig(newClientId);
    }
  }

  useEffect(() => {
    AppConfig.init(window.location.hostname)
      .then(() => {
        assureClientId()
          .then(() => {
            setInInit(false);
          })
      });
  }, []);

  return inInit ? null : (
    <ReduxStoreProvider store={store}>
      <Router basename={baseUrl} history={browserHistory}>
        <WebWorkspace />
      </Router>
    </ReduxStoreProvider>
  );
}
